import Service from "../Service";
import AuthService from "../AuthService";
import Auth from "./Auth";

const Result = {
  fixTestIssue(ln) {
    return Service.get(`fix-test-issue/${ln}`);
  },
  deleteResult(id, token) {
    return AuthService.get(`delete-result/${id}?token=${token}`);
  },
  getLastResultOfAnimal(animalId, testId, isSubTest = false) {
    return AuthService.post(`test-result-history`, {
      animalId,
      testId,
      isSubTest,
    });
  },
  filterResult(request) {
    return Service.get(`result-raw-data?page=${request.page_no}`);
  },
  getAllResults() {
    return Service.get(`result-raw-data`);
  },
  getResult(id) {
    return Service.get(`result/${id}`);
  },
  getResultDB(id) {
    return AuthService.get(`result-db/${id}`);
  },
  editResult(request) {
    return AuthService.post(`result-db`, request);
  },
  getRemarks() {
    return AuthService.get(`remarks`);
  },
  getSettingRemark() {
    return AuthService.get(`settings/remarks`);
  },
  createSettingRemark(payload, token) {
    return AuthService.post(`settings/remarks?token=${token}`, payload);
  },
  updateSettingRemark(payload, id, token) {
    return AuthService.put(`settings/remarks/${id}?token=${token}`, payload);
  },
  deleteSettingRemark(id, token) {
    return AuthService.delete(`settings/remarks/${id}?token=${token}`);
  },
  deleteFileUpload(id) {
    return AuthService.delete(`results/files/${id}`);
  },
  printSummary() {
    return AuthService.get(`results/report-summary`);
  },
  multiprint(payload) {
    return AuthService.post(`v2/print-multiple-report`, payload);
  },
};

export default Result;
